import Input, { InputProps } from '@components/atoms/Input';

export const Datepicker = ({
  value,
  ...rest
}: { value?: string } & Omit<InputProps, 'value' | 'transform' | 'type'>) => {
  return <Input value={value ?? ''} type="date" {...rest} />;
};
